/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Customers_Empty_BodyInputs */



/**
* | output |
* | --- |
* | "Add your first customer to get started." |
*
* @param {Partner_Customers_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customers_empty_body = /** @type {((inputs?: Partner_Customers_Empty_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customers_Empty_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie Ihren ersten Kunden hinzu, um zu starten.")
	return /** @type {LocalizedString} */ ("Add your first customer to get started.")
});